// Run theme bootstrap BEFORE any Vue/Pinia code so the `.dark` class is on
// `<html>` before the first paint (anti-FOUC). The store still owns runtime
// reactivity (matchMedia listener, mode cycling) — this is just the one-shot
// pre-mount application.
import { bootstrapTheme } from './lib/themeBootstrap'
bootstrapTheme()

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'leaflet/dist/leaflet.css'
import './style.css'
import './styles/ui.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
